export default __webpack_public_path__ + "components/weather-icon/static/daythunderstorm-adc318890045ddaf265988380cf099e0.png";